import { createFormatForDescription as cffd } from '../createFormatForDescription'
import {
  SignerEntryExplanation,
  createSignerEntryExplanation,
} from '../explain/ExplainSignerEntry'
import { Explanation, explain, explainArray } from '../explain/Explanation'
import SignerListSetInstructions from '../types/instructions/SignerListSetInstructions'
import TransactionType from '../types/TransactionType'

/**
 * An annotation for SignerListSet transactions.
 *
 * @property type - The transaction type.
 * @property signerEntries - An explanation of the signerEntries.
 * @property signerQuorum - An explanation of the signerQuorum.
 */
export interface SignerListSetAnnotation {
  readonly type: TransactionType.SignerListSet

  readonly signerEntries: Explanation<SignerEntryExplanation[]>
  readonly signerQuorum: Explanation<number>
}

/**
 * Takes a transaction object and returns an annotated transaction object.
 * The returned object contains explanations about the various transaction features.
 *
 * @param transactionInstructions - The input transaction.
 * @returns An annotated transaction object detailing the various transaction features.
 */
export function annotate(
  transactionInstructions: SignerListSetInstructions,
): SignerListSetAnnotation {
  const signerQuorum = explain(
    transactionInstructions.SignerQuorum,
    `The multi-signature needs a combined weight of ${cffd(
      transactionInstructions.SignerQuorum.toString(),
      'signerQuorum',
    )} to be valid.`,
  )

  const signerEntries = explainArray(
    transactionInstructions.SignerEntries,
    createSignerEntryExplanation,
    'The accounts that can contribute to the multi-signature:',
  )

  return {
    type: TransactionType.SignerListSet,
    signerQuorum,
    signerEntries,
  }
}
